module.exports = __webpack_public_path__ + "img/logo.822e59ab.png";